<!--  -->
<template>
  <div class="downApp" v-show="show">
    <div class="box">
      <div class="title"><div class="close" @click="changeShow"></div></div>
      <div class="content">
        <h1>复制下方口令</h1>
        <h2>下载并打开app即可获得抽卡次数</h2>
        <div id="qrcode" ref="qrcode"></div>
        <p>长按/截图保存图片并打开呦~</p>
        <button @click="copyLink">复制口令</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// const CryptoJS = require('crypto');
import { encodeAesString } from '@/utils/aes';
import { copyTool, judgmentPlatform } from '@/utils/tools';
import { reqAppVersion } from '@/api/collectCard';

export default {
  components: {},
  data() {
    return {
      show: false,
      isApp: this.$root.isApp,
      miniprogram: this.$root.miniprogram,
    };
  },
  props: {
    activityId: {
      type: Number,
      default: 0,
    },
    currentTask: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
      if (this.show) {
        this.getAppVersion();
      }
    },
    async getAppVersion() {
      let url = 'itms-apps://itunes.apple.com/app/id1172161344';
      if (judgmentPlatform() === 'android') {
        const { data } = await reqAppVersion();
        url = data;
      }
      this.creatQrCode(url);
    },
    async creatQrCode(url) {
      const canvas = this.$refs.qrcode;
      canvas.innerHTML = '';
      await new QRCode(canvas, {
        text: url,
        width: 178,
        height: 178,
      });
    },
    copyLink() {
      const params = JSON.stringify({
        cardActivityId: this.activityId,
        cardTaskId: this.currentTask.id,
        userId: this.userInfo.id,
        type: 1, //1.抽卡活动
        source: this.miniprogram ? 2 : 1,
      });
      const encodeAes = encodeAesString(params);
      const copyRes = `【启航教育】 ${encodeAes} 复制口令到APP`;
      console.log(copyRes,333);

      copyTool(copyRes)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.downApp {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 621px;
    height: 750px;
    background: #fff;
    border-radius: 40px;
    transform: translate(-50%, -50%);
    .title {
      position: relative;
      width: 100%;
      height: 291px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/down-app.png') no-repeat;
      background-size: 100%;
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 10;
        width: 40px;
        height: 40px;
        background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/collectCard/close1.png');
        background-size: 100%;
      }
    }
    .content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      text-align: center;
      h1 {
        padding-top: 38px;
        padding-bottom: 42px;
        color: #333;
        font-size: 32px;
        text-align: center;
      }
      h2 {
        padding-bottom: 29px;
        color: #333;
        font-size: 28px;
        text-align: center;
      }
      #qrcode {
        width: 360px;
        height: 360px;
        margin: 0 auto;
        border-radius: 30px;
        // animation: rotate 3s linear infinite; /* 应用动画 */
        // transform: scale(0.8, 1.5) rotate(35deg) skew(5deg) ;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        padding: 33px 0 28px 0;
        color: #333;
        font-weight: 400;
        font-size: 28px;
      }
      button {
        width: 300px;
        height: 80px;
        color: #fff;
        font-weight: 400;
        font-size: 32px;
        line-height: 80px;
        background: #ff7f41;
        border-radius: 44px;
      }
    }
  }
  @keyframes rotate {
    from {
      transform: scale(0.8); /* 动画开始时的状态 */
      transform: rotate(35deg);
      transform: rotate(15deg);
    }
    to {
      transform: scale(1.8); /* 动画结束时的状态 */
      transform: rotate(0);
      transform: rotate(45deg);
    }
  }
}
</style>
